module.exports = __webpack_public_path__ + "static/img/guide-topico1.76cc358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide-topico1.png
// module id = A69I
// module chunks = 1